<template>
  <div
    v-loading="loading"
    element-loading-background="rgba(255, 255, 255, 0.3)"
    element-loading-spinner="el-icon-loading"
    class="with-spinner-loading"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'WithSpinnerLoading',
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style lang="scss">
.with-spinner-loading {
  min-height: rem-calc(20px);
}
</style>
